import { Component, Input, OnInit } from '@angular/core';
import { LaunchDarklyService } from '../../../core/services/launchdarkly.service';
import { RepoCommonService } from '../../../data/repositories/repo-common.service';
import { LayoutService } from '../../layout/layout.service';

@Component({
    selector: 'app-contact-view',
    templateUrl: './contact-view.component.html',
    standalone: false,
})
export class ContactViewComponent implements OnInit {
    // @ts-ignore TS7008
    @Input() contact;
    // @ts-ignore TS2564
    title: string;

    contactTypesList$: any;
    contactGroupsList$: any;
    showNewNav: boolean = false;

    constructor(
        private common: RepoCommonService,
        private layoutService: LayoutService,
        private lds: LaunchDarklyService
    ) {}
    ngOnInit() {
        this.common.GetContactGroups().then((results) => {
            this.contactGroupsList$ = results.map((x) => x.Description).sort();
        });
        this.common.GetContactTypes().then((results) => {
            this.contactTypesList$ = results.map((x) => x.Description).sort();
        });
    }

    showSecondaryNav() {
        return this.layoutService.showSecondaryNav();
    }

    getSecondaryNavClasses() {
        return this.layoutService.getSecondaryNavClasses();
    }
}
